import React from 'react';
import {DonationBreadcrumb} from './DonationBreadcrumb';
import braintree from 'braintree-web-drop-in'
import BraintreeDropin from 'braintree-dropin-react';
import {RegionDropdown} from 'react-country-region-selector'
import $ from 'jquery';
import DonorLanguagePdf from '../WMCEF_Donor Langauge.pdf';
import { ReCaptcha } from 'react-recaptcha-google'

class DonateContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  componentWillMount(){
    this.setState ({
      amount: '',
      firstName: '',
      lastName: '',
      email: '',
      website: '',
      streetAddress1: '',
      streetAddress2: '',
      city: '',
      region: '',
      postalCode: '',
      eAmount: false,
      eFirstName: false,
      eLastName: false,
      eEmail: false,
      eStreetAddress1: false,
      eCity: false,
      eRegion: false,
      ePostalCode: false,
      submitAttempted: false,
      displayResult: false,
      responseMessage: '',
      paymentPhase: 1,
      recaptchaLoaded: false,
      recaptchaToken: undefined,
    });
  }

  componentDidMount() {
    if (this.captchaDemo) {
        console.log("started, just a second...")
        this.captchaDemo.reset();
    }
  }
  onLoadRecaptcha() {
    this.setState({recaptchaLoaded: true});
      if (this.captchaDemo) {
          this.captchaDemo.reset();
      }
  }

  verifyCallback(recaptchaToken) {
    // get recaptcha token  
    this.setState({ recaptchaToken: recaptchaToken});
    // console.log(recaptchaToken, "<= your recaptcha token");
  }

  handleBillingInfo = () => {
    this.validateFirstName(this.state.firstName);
    this.validateLastName(this.state.lastName);
    this.validateEmail(this.state.email);
    this.validateAddr(this.state.streetAddress1);
    this.validateCity(this.state.city);
    this.validateRegion(this.state.region);
    this.validatePostalCode(this.state.postalCode);
    this.validateAmount(this.state.amount);
    this.setState({submitAttempted: true},()=>{
      console.log(this.state);
      if (['eAmount', 'eFirstName', 'eLastName', 'eEmail', 'eStreetAddress1', 'eCity', 'eRegion', 'ePostalCode'].every(i=>{console.log(i,this.state[i]); return !this.state[i];})) this.setState({paymentPhase: 2});
    });
  }

  handlePaymentMethod = (payload) => {
    // check for captcha
    if (this.state.recaptchaToken === undefined) {
      alert("Please complete the reCAPTCHA");
      return;
    }

    // When the user clicks on the 'Submit payment' button this code will send the
    // encrypted payment information in a variable called a payment method nonce
    var me=this;

    $('.braintree-dropin-react-submit-btn-wrapper').remove();
    $.ajax({
      type: 'POST',
      url: '/api/checkout',
      data: {
        'paymentMethodNonce': payload.nonce,
        'amount':this.state.amount,
        'firstName':this.state.firstName,
        'lastName':this.state.lastName,
        'email': this.state.email,
        'website': this.state.website,
        'streetAddress': this.state.streetAddress1,
        'extendedAddress': this.state.streeAddress2,
        'locality': this.state.city,
        'region': this.state.region,
        'postalCode': this.state.postalCode,
        'grecaptchaResponse': this.state.recaptchaToken,
      }
    }).done(function(result) {
      if (result.success) {
        var creAt = new Date(result.transaction.createdAt);
        me.setState({responseMessage:(
          <div className="success-response">
            <h3>Thank you!</h3>
            <p>Your payment of <strong>${result.transaction.amount}</strong> has successfully been submitted for settlement from <strong>{result.transaction.creditCard.cardType}</strong> ending in <strong>{result.transaction.creditCard.last4}</strong> on {creAt.toLocaleString()}<br/>Confirmation #: {result.transaction.id}</p>
            <p>An emailed receipt will be sent out to you in the next few business days.</p>
          </div>
        )});
      } else {
        if (result.transaction){
          me.setState({responseMessage:(
            <div className="error-response">
              <p>Sorry, there was a problem with this transaction. Please try another payment option. If you think there has been a mistake, please contact us.</p>
            </div>
          )});
        }
        else {
          me.setState({responseMessage: (
            <div className="error-response">
              <p>An unexpected error has occured. Please contact the administrator to resolve the issue</p>
            </div>
          )});
        }
      }
      me.setState({paymentPhase:3})
    });
  };

  validateFirstName = (val) => {
    this.setState({eFirstName:/^\s*$/.test(val)});
  }

  handleFirstNameChange = (event) => {
    this.setState({firstName: event.target.value});
    this.validateFirstName(event.target.value);
  }

  validateLastName = (val) => {
    this.setState({eLastName:/^\s*$/.test(val)});
  }

  handleLastNameChange = (event) => {
    this.setState({lastName: event.target.value});
    this.validateLastName(event.target.value);
  }

  validateEmail = (val) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({eEmail: !re.test(val.toLowerCase())});
  }

  handleEmailChange = (event) => {
    this.setState({email: event.target.value});
    this.validateEmail(event.target.value)
  }

  handleWebsiteChange = (event) => {
    this.setState({website: event.target.value});
  }

  validateAddr = (val) => {
    this.setState({eStreetAddress1:/^\s*$/.test(val)});
  }

  handleAddr1Change = (event) => {
    this.setState({streetAddress1: event.target.value});
    this.validateAddr(event.target.value);
  }

  handleAddr2Change = (event) => {
    this.setState({streetAddress2: event.target.value});
  }

  validateCity = (val) => {
    this.setState({eCity:/^\s*$/.test(val)});
  }

  handleCityChange = (event) => {
    this.setState({city: event.target.value})
    this.validateCity(event.target.value)
  }

  validateRegion = (val) => {
    this.setState({eRegion:/^\s*$/.test(val)});
  }

  handleRegionChange = (value) =>{
    this.setState({region: value});
    this.validateRegion(value);
  }

  validatePostalCode = (val) => {
    this.setState({ePostalCode: !(/^\d{5}$/.test(val))});
  }

  handlePostalCodeChange = (event) =>{
    this.setState({postalCode: event.target.value});
    this.validatePostalCode(event.target.value);
  }

  validateAmount = (val) => {
    this.setState({eAmount: !(/^\d+(?:\.\d{2})?$/.test(val))});
  }

  handleAmountChange = (event) => {
    this.setState({amount: event.target.value});
    this.validateAmount(event.target.value);
  };

  onCreate = (instance) => {
    console.log('onCreate')
  }

  onDestroyStart = () => {
    console.log('onDestroyStart')
  }

  onDestroyEnd = () => {
    console.log('onDestroyEnd')
  }

  onError = (error) => {
    console.log(error);
  }

  getCurrentView = () => {
    if (this.state.paymentPhase===1){
      return (
        <div className="row transaction-form">
          <div className="col-md-6">
            <form>
              <span className="donationLabel">First Name: </span><br />
              <div className="input-group">
                <input type="text" className={((this.state.eFirstName)?"error ":"")+"form-control"} value={this.state.firstName} onChange={this.handleFirstNameChange} />
              </div>
              {
                (this.state.eFirstName && this.state.submitAttempted)?(
                  <p className="form-error">This is a required field</p>
                ):(
                  <i/>
                )
              }

              <span className="donationLabel">Last Name: </span><br />
              <div className="input-group">
                <input type="text" className={((this.state.eLastName)?"error ":"")+"form-control"} value={this.state.lastName} onChange={this.handleLastNameChange} />
              </div>
              {
                (this.state.eLastName && this.state.submitAttempted)?(
                  <p className="form-error">This is a required field</p>
                ):(
                  <i/>
                )
              }

              <span className="donationLabel">Email Address: </span><br/>
              <div className="input-group">
                <input type="text" spellCheck="false" className={((this.state.eEmail)?"error ":"")+"form-control"} value={this.state.email} onChange={this.handleEmailChange} />
              </div>
              {
                (this.state.eEmail && this.state.submitAttempted)?(
                  <p className="form-error">{this.state.email?"Please enter a valid email":"This is a required field"}</p>
                ):(
                  <i/>
                )
              }

              <span className="donationLabel website">Website: </span><br/>
              <div className="input-group website">
                <input type="text" spellCheck="false" className={"form-control"} value={this.state.website} onChange={this.handleWebsiteChange} />
              </div>

              <hr/>

              <h6>Billing Address</h6>

              <span className="donationLabel">Street Address 1: </span><br/>
              <div className="input-group">
                <input type="text" className={((this.state.eStreetAddress1)?"error ":"")+"form-control"} value={this.state.streetAddress1} onChange={this.handleAddr1Change}/>
              </div>
              {
                (this.state.eStreetAddress1 && this.state.submitAttempted)?(
                  <p className="form-error">This is a required field</p>
                ):(
                  <i/>
                )
              }

              <span className="donationLabel">Street Address 2: </span><br/>
              <div className="input-group">
                <input type="text" className="form-control" value={this.state.streetAddress2} onChange={this.handleAddr2Change}/>
              </div>

              <span className="donationLabel">City: </span><br/>
              <div className="input-group">
                <input type="select" className={((this.state.eCity)?"error ":"")+"form-control"} value={this.state.city} onChange={this.handleCityChange} />
              </div>
              {
                (this.state.eCity && this.state.submitAttempted)?(
                  <p className="form-error">This is a required field</p>
                ):(
                  <i/>
                )
              }

              <span className="donationLabel">State: </span><br/>
              <div className="input-group">
                <RegionDropdown
                  country={'United States'}
                  value={this.state.region}
                  onChange={this.handleRegionChange}
                  defaultOptionLabel="Select State"
                  valueType="short"
                  classes={((this.state.eRegion)?"error ":"")+"form-control"}/>
              </div>
              {
                (this.state.eRegion && this.state.submitAttempted)?(
                  <p className="form-error">This is a required field</p>
                ):(
                  <i/>
                )
              }

              <span className="donationLabel">Postal Code: </span><br/>
              <div className="input-group">
                <input type="text" className={((this.state.ePostalCode)?"error ":"")+"form-control"} value={this.state.postalCode} onChange={this.handlePostalCodeChange} />
              </div>
              {
                (this.state.ePostalCode && this.state.submitAttempted)?(
                  <p className="form-error">{this.state.postalCode?"Please enter a valid ZIP":"This is a required field"}</p>
                ):(
                  <i/>
                )
              }

              <hr/>

              <span className="donationLabel">Donation Amount: </span><br />
              <div className="input-group">
                <div className="input-group-addon">$</div>
                <input type="text" className={((this.state.eAmount)?"error ":"")+"form-control"} value={this.state.amount} onChange={this.handleAmountChange} />
              </div>
              {
                (this.state.eAmount && this.state.submitAttempted)?(
                  <p className="form-error">{this.state.amount?"Not a valid format":"This is a required field"}</p>
                ):(
                  <i/>
                )
              }
                <input type="button" className="btn-default billing-submit" onClick={()=>this.handleBillingInfo()} value="Continue" />
            </form>
          </div>
        </div>
      );
    } else if (this.state.paymentPhase===2){
      return (
        <div>
          <div className="review-info row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-lg-6">
                  <h5>Name: </h5>
                </div>
                <div className="col-lg-6">
                  <p>{this.state.firstName+" "+this.state.lastName}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <h5>Email: </h5>
                </div>
                <div className="col-lg-6">
                  <p>{this.state.email}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <h5>Billing Address: </h5>
                </div>
                <div className="col-lg-6">
                  <p>{this.state.streetAddress1}</p>
                  {this.state.streetAddress2!==''?(<p>{this.state.streetAddress2}</p>):''}
                  <p>{this.state.city+", "+this.state.region + " " + this.state.postalCode}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <h5>Donation Amount: </h5>
                </div>
                <div className="col-lg-6">
                  <p>{this.state.amount}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <ReCaptcha
                  ref={(el) => {this.captchaDemo = el;}}
                  size="normal"
                  data-theme="dark"
                  render="explicit"
                  sitekey="6LePw8IUAAAAABKCi3dvHcYKPA-FcRFWsMVBd8pQ"
                  onloadCallback={this.onLoadRecaptcha}
                  verifyCallback={this.verifyCallback}
                />
                <BraintreeDropin
                  braintree={braintree}
                  authorizationToken='production_4tz2ycbg_zh2m9rddzwy2px2r'
                  handlePaymentMethod={this.handlePaymentMethod}
                  onCreate={this.onCreate}
                  onDestroyStart={this.onDestroyStart}
                  onDestroyEnd={this.onDestroyEnd}
                  onError={this.onError}>
                </BraintreeDropin>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-md-12">
          {this.state.responseMessage}
        </div>
      )
    }
  }

  render() {
    return (
      <div className="main donate-page">
        <section>
          <div className="container">
          <div className="offset"></div>
            <div className="row">
              <h1 className="title">Donate to Help Educate the Next Generation of Surveyors</h1>
              <p className="donation-page-text">
                    Your valuable contribution of any amount will directly assist those individuals interested in pursuing a career in Surveying, Mapping, or Geomatics.
                    The Walter M. Cunningham Education Foundation currently funds several student scholarships each year and we anticipate this will continue.
                    The long-term goal is to directly support higher education programs with current instrumentation and supplies as well as contribute to student
                    capstone projects and other student lead projects, competitions, and off-campus excursions and events. The Walter M. Cunningham Foundation is
                    a <a href = {DonorLanguagePdf} target = "_blank">501(c)(3) non-profit corporation</a>. All donations are tax deductible.
              </p>
              <div className="warning-text-block">
                <p className="warning-text">
                  We have been experiencing a high volume of fraudulent transactions and have had to temporarily shut down the donation portal.
                  <br /><br />
                  To make a donation, please contact Susan at <a className="warning-text" href="mailto:susan@wmcef.org">susan@wmcef.org</a>.
                </p>
              </div>
            </div>
            <DonationBreadcrumb active={this.state.paymentPhase} />
            {this.getCurrentView()}
          </div>
        </section>
      </div>
    )
  };
};


export default DonateContent;



// WEBPACK FOOTER //
// ./src/components/DonateContent.js